/**
 * HTTP Client Error Constants
 *
 * @module lib/http/errors
 */

export const TOKEN_EXPIRED = 'TokenExpiredError';
export const FRONTEND_ERROR_CODE = 501;
export const FRONTEND_ERROR_API_NAME = 'ErrorFrontendApiClient'; // 30 seconds

/**
 * Request timeout error name
 */
export const TIMEOUT_ERROR_NAME = 'TimeoutError';

/** The selected machine has no signal source (orchestrator, 422). */
export const MISSING_SIGNAL_SOURCE_ERROR_NAME = 'MissingSignalSource';

/** The newest part on the machine holds no pass of the lab block (signals_provider, 422). */
export const NO_MACHINING_PASS_ERROR_NAME = 'NoMachiningPass';

/** The signal source holds no data in the last 90 days (signals_provider, 422). */
export const MISSING_SIGNAL_DATA_ERROR_NAME = 'MissingSignalData';

/** The tool ID is already registered by another company (tracabilite_storage, 409). */
export const TOOL_ID_TAKEN_ERROR_NAME = 'DBToolIdTakenError';
